var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.initCode && _vm.$route.name != 'CartRecap' && _vm.selfscanningPages)?_c('CartRecap'):_vm._e(),_c('v-container',{staticClass:"ssc-section",class:{
      'shoping-started':
        _vm.initCode && _vm.$route.name != 'CartRecap' && _vm.selfscanningPages
    }},[_c('router-view')],1),(_vm.selfscanningPages)?_c('BottomActionBar',{attrs:{"initCode":_vm.initCode},on:{"init":_vm.init,"add":function($event){return _vm.scan('add')},"remove":function($event){return _vm.scan('remove')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }